import React from "react";

const Footer = () => {
    return (
        <div className="bg-lightBlack py-4">
            <div className="text-center mt-4">
                Made with <span className="text-red-500">❤️</span> by Vaani Pathariya
            </div>
        </div>
    );
}

export default Footer;
